<section class="ai-chat-simple-input" [attr.aria-label]="question">
  <p *ngIf="question" class="question">
    <fastr-ui-streaming-text
      *ngIf="animateQuestion; else settledQuestion"
      [text]="question"></fastr-ui-streaming-text>
    <ng-template #settledQuestion>{{ question }}</ng-template>
  </p>

  <fastr-ui-ai-chat-custom-value
    [(value)]="value"
    [placeholder]="placeholder"
    [showVoiceIcon]="showVoiceIcon"
    (submitted)="submit()">
  </fastr-ui-ai-chat-custom-value>

  <fastr-ui-ai-chat-actions
    [showSecondaryActions]="showSecondaryActions"
    [showBackAction]="showBackAction"
    [reviewAndSearchLabel]="reviewAndSearchLabel"
    [refineLabel]="refineLabel"
    [continueLabel]="continueLabel"
    [reviewAndSearchDisabled]="isReviewAndSearchDisabled()"
    [refineDisabled]="isRefineDisabled()"
    [continueDisabled]="!canSubmit()"
    (reviewAndSearch)="submitReviewAndSearch()"
    (refine)="submitRefine()"
    (backed)="submitBack()"
    (continued)="submit()">
  </fastr-ui-ai-chat-actions>
</section>
